import {
  ebsPassportSnilsPng,
  ebsPassportPng,
  ebsBiometryPng,
  ebsAppPng,
  ebsTabletPng,
  ebsDocumentsPng,
  ebsProfilePng,
} from '@src/assets';
import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';
import { sendClickEsiaEbsBanner, sendClickEsiaLkEbsBanner } from '@src/helpers/analyticsEvents';

import { EbsCustomAlert } from './components/EbsCustomAlert/EbsCustomAlert';
import type { IEbsInformerProps } from './components/EbsInformer/EbsInformer';

export const EBS_APP_LINK = `https://ebs.ru/verification_gosuslugi`;
export const EBS_ESIA_LK_LINK = `https://esia.gosuslugi.ru/login/`;

export const EBS_RADIO_OPTIONS = [
  {
    label: 'Стандартная',
    value: 1,
  },
  {
    label: 'Подтверждённая',
    value: 2,
  },
];

export const defaultImageSize = {
  desktop: {
    width: 87,
    height: 120,
  },
  mobile: {
    width: 60,
    height: 84,
  },
};

export const EBS_DEFAULT_CONTENT = (isMobile: boolean): IEbsInformerProps[] => [
  {
    title: (
      <div>
        Скачайте приложение <br />
        <a href={EBS_APP_LINK} target="_blank" rel="noreferrer noopener" onClick={sendClickEsiaEbsBanner}>
          «Госуслуги Биометрия»
        </a>
      </div>
    ),
    image: ebsAppPng,
    imageSize: isMobile ? defaultImageSize.mobile : defaultImageSize.desktop,
    imageStyles: {
      marginRight: '11px',
    },
  },

  {
    title: isMobile ? (
      <>
        Войдите{UNBREAKABLE_SEPARATOR}в{UNBREAKABLE_SEPARATOR}Госуслуги{UNBREAKABLE_SEPARATOR}и{UNBREAKABLE_SEPARATOR}
        дайте
        <br /> согласие на обработку данных
      </>
    ) : (
      <>Войдите в Госуслуги и дайте согласие на обработку данных</>
    ),
    image: ebsPassportSnilsPng,
    imageSize: isMobile ? defaultImageSize.mobile : defaultImageSize.desktop,
    imageStyles: {
      marginRight: '11px',
    },
  },
  {
    title: <>Сделайте селфи, следуя подсказкам на экране</>,
    image: ebsPassportPng,
    imageSize: isMobile ? defaultImageSize.mobile : defaultImageSize.desktop,
    imageStyles: {
      marginRight: '11px',
    },
  },
  {
    title: `Готово! У вас теперь есть стандартная биометрия`,
    image: ebsBiometryPng,
    imageSize: isMobile ? defaultImageSize.mobile : defaultImageSize.desktop,
    imageStyles: {
      marginRight: '11px',
    },
  },
];

export const EBS_CONFIRM_CONTENT = (isMobile: boolean): IEbsInformerProps[] => [
  {
    title: 'Выберите любой ближайший офис банка',
    subtitle: (
      <EbsCustomAlert
        isSmallFont
        content={
          <>
            Быть клиентом банка не обязательно, эта{UNBREAKABLE_SEPARATOR}услуга{UNBREAKABLE_SEPARATOR}совершенно
            бесплатная
          </>
        }
      />
    ),
  },
  {
    title: `Не забудьте паспорт и${UNBREAKABLE_SEPARATOR}СНИЛС для${UNBREAKABLE_SEPARATOR}регистрации`,
    image: ebsDocumentsPng,
    imageSize: {
      width: isMobile ? 80 : 105,
      height: isMobile ? 80 : 105, // пример
    },
    imageStyles: {
      marginRight: '11px',
    },
  },
  {
    title: `Сотрудник банка сделает ваше фото и запишет голос`,
    image: ebsTabletPng,
    imageSize: {
      height: isMobile ? 86 : 123,
      width: isMobile ? 88 : 105,
    },
  },
  {
    title: isMobile ? (
      <span>
        Управлять биометрией <br /> можно
        <a
          href={EBS_ESIA_LK_LINK}
          target="_blank"
          style={{ textDecoration: 'none' }}
          rel="noreferrer noopener"
          onClick={sendClickEsiaLkEbsBanner}
        >
          {UNBREAKABLE_SEPARATOR}в{UNBREAKABLE_SEPARATOR}личном кабинете <br /> Госуслуг
        </a>
      </span>
    ) : (
      <span>
        Управлять биометрией можно
        <a
          href={EBS_ESIA_LK_LINK}
          target="_blank"
          style={{ textDecoration: 'none' }}
          rel="noreferrer noopener"
          onClick={sendClickEsiaLkEbsBanner}
        >
          {UNBREAKABLE_SEPARATOR}в{UNBREAKABLE_SEPARATOR}личном кабинете Госуслуг
        </a>
      </span>
    ),
    image: ebsProfilePng,
    imageSize: isMobile ? defaultImageSize.mobile : defaultImageSize.desktop,
    imageStyles: {
      marginRight: '11px',
    },
  },
];
